import React from "react";
import {Modal} from 'antd';
import getSize from "../../../../utils/getSize";
import NHFetch from "../../../../utils/NHFetch";
import css from './index.css';
import JxJxfzcx from "../jxJxfzcx";//基线
import ScjtJxfzcx from "../scjtJxfzcx";//四川交通

const confirm = Modal.confirm;

const baseUrlPath = "/swbl/lstd"; //基础路径
/**
 * 军训服装查询列表
 * @author liudongbin
 * @date 2021年7月30日 10点24分
 * Version: 1.0
 */
class index extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            menuCode: [],//null是基线
        };
    }

    componentDidMount() {
        this.getMenuCode();
    }

    getMenuCode = () => {
        let cds = ["jxfzcx"];
        NHFetch(baseUrlPath + '/getXmdcd', 'POST', cds).then(res => {
            if (res) {
                if (res && res.code == 200) {
                    let menuCode = res.data;
                    this.setState({
                        menuCode
                    })
                }
            }
        });
    }

    render() {
        const {menuCode} = this.state;
        return (
          <div>
              {
                  menuCode && menuCode.length > 0 && menuCode.map((item, index) => {
                      if (item.JC == "scjt") {
                          return <ScjtJxfzcx/>
                      } else {
                          return <JxJxfzcx/>
                      }
                  })
              }
              {(menuCode == null || menuCode.length == 0) && <JxJxfzcx/>}
          </div>
        );
    }
}

export default index;



// WEBPACK FOOTER //
// ./components/tjcx/jxfzcx/tyJxfzcx/index.js